"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLayoutItem = exports.GridLayout = void 0;
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var GridLayout = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray([
        "l-grid",
        props.gap ? "+gap-" + props.gap : "",
        props.columns ? "+cols-" + props.columns : "",
        props.columnsSmall ? "+cols-" + props.columnsSmall + "@s" : "",
        props.columnsMedium ? "+cols-" + props.columnsMedium + "@m" : "",
        props.columnsLarge ? "+cols-" + props.columnsLarge + "@l" : ""
    ], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.GridLayout = GridLayout;
var GridLayoutItem = function (props) {
    var utilityClasses = distillUtilityClasses_1.default(props)[0];
    var classes = __spreadArray([
        "l-grid__item",
        props.span ? "+span-" + props.span : "",
        props.inset ? "+inset-" + props.inset : "",
        props.fraction ? "+fr-" + props.fraction : "",
        props.insetFraction ? "+insetfr-" + props.insetFraction : ""
    ], utilityClasses);
    return react_1.default.createElement("div", { className: classes.join(" ") }, props.children);
};
exports.GridLayoutItem = GridLayoutItem;
exports.GridLayout.Item = exports.GridLayoutItem;
//# sourceMappingURL=GridLayout.js.map